import { Component, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject, Subscription } from 'rxjs';
import * as written from 'written-number';
import { DashboardSupersendComponent } from '../../dash-board/dashboard-supersend/dashboard-supersend.component';
import { currentcartdetail, ShopingCart } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { AdditionalRequired, PaymentDetails, PickupType, SendMoneyDetail } from '../../models/sendmoney/sendmoney';
import { enumEventype, UserProfileTMNIovation } from '../../models/user/user.tm.profile.model';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { AdditionalInfoPopupComponent } from 'app/sendmoney/_modalpopup/additional-info-popup/additional-info-popup.component';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList, PaymentType } from '../../sharedcomponents/_common/constants/app.constants';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { AmountFormat, MyCurrencyPipe } from '../../sharedcomponents/_pipe/mycurreny';
import { uploaddocumtuserprofilestep1 } from '../../user/user-register/user-document-upload/userprofile-document-upload.component-Step1';
import { uploaddocumtuserprofilestep2 } from '../../user/user-register/user-document-upload/userprofile-document-upload.component-Step2';
import { CartServiceService } from '../../_services/dashboardservice/cart/cart-service.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { AuthService } from '../../_services/userservice/auth.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { dashboardlandingpageservice } from '../../_services/dashboardservice/dash-board.service';

import { ThreatMetrixService } from '../../_services/ThreatMetrix/threatmetrix'

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.css'],
    providers: [Modal, CountryService, AuthService, MyCurrencyPipe, AmountFormat, dashboardlandingpageservice, ThreatMetrixService]
})
export class SummaryComponent implements OnInit, OnDestroy {
    isFormValid: boolean;

    sendMoneyDetail: SendMoneyDetail;
    paymentDetails: PaymentDetails;
    model: any = {};
    beneficiaryData: any;
    beneficiaryList: any;
    srcRadio: boolean;
    dstRadio: boolean;
    summaryData: any = {};
    currentcart: currentcartdetail;
    userGioLoc: UserGioLocation;
    shopingCart: ShopingCart;
    shopingCartList: any;
    buttonName: string = '';
    appSettings: any;
    Rate: number;
    Fee: number;
    TaxAmount: number;
    paymentType: any;
    // PageFlow: {};
    subscription: Subscription;
    fraudSubAddbank: Subscription;
    fraudSubPay: Subscription;
    unsubjectShoppingCart: Subscription;
    private subjectShoppingCart = new Subject<boolean>();
    fraudDetectionPromise: Promise<any>;
    @Output()
    subjectShoppingCartObservable = this.subjectShoppingCart.asObservable();

    actionFlag: boolean = false; // it notifies weather it is for add to cart or supersend call in branch details
    isDocUploaded: boolean = false;
    DocumentRequired: {};
    isBranchDetailsUpdated: boolean = false;
    isGeolocationUpdated: boolean = false;
    private clickStream = new Subject<boolean>();
    @Output()
    observable = this.clickStream.asObservable();

    unsubGeoPermisson: any;
    private subGeoPermisson = new Subject<boolean>();
    @Output()
    observableGeoPermisson = this.subGeoPermisson.asObservable();

    unsubDocReq: any;
    private subDocReq = new Subject<boolean>();
    @Output()
    observableDocReq = this.subDocReq.asObservable();

    private subfraudPay = new Subject<boolean>();
    @Output()
    subfraudPayObservable = this.subfraudPay.asObservable();

    private subfraudAddbank = new Subject<boolean>();
    @Output()
    subfraudSubAddbank = this.subfraudAddbank.asObservable();

    private subSupersendCall = new Subject<boolean>();
    // @Output()
    // subfraudSubAddbank = this.subSupersendCall.asObservable();

    userProfileTMNIovation: UserProfileTMNIovation;
    srcCountryImage: any;
    destCountryImage: any;
    isModalOpen = false;
    countrycollection = [];
    RoundingPlaces: number = AppSettings.fractionDigit;
    srcAmount: number;
    constructor(
        private router: Router,
        private countryserv: CountryService,
        private userCommon: usercommonattribute,
        private sendMoneyService: SendMoneyService,
        private cartservice: CartServiceService,
        public utilityServ: utilityService,
        public modal: Modal,
        private translate: TranslateService,
        private geoloc: geolocation,
        public domSanitizer: DomSanitizer,
        private vcRef: ViewContainerRef,
        private currencyPipe: MyCurrencyPipe,
        private auth: AuthService,
        private amountFormat: AmountFormat,
        private dbService: dashboardlandingpageservice,
        private threatMetrixService: ThreatMetrixService
    ) {
        this.isFormValid = true;
        this.paymentType = PaymentType;
        this.appSettings = AppSettings;
        this.sendMoneyDetail = new SendMoneyDetail();
        const unsubSendMoneyDetailData = this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
            this.sendMoneyDetail = data;
            if (unsubSendMoneyDetailData != undefined) {
                unsubSendMoneyDetailData.unsubscribe();
            }
        });
        this.paymentDetails = this.sendMoneyDetail.paymentDetails;
        this.Rate = Number(this.paymentDetails.exchangeRate);
        this.Fee = Number(this.paymentDetails.processingFee);
        this.TaxAmount = Number(this.paymentDetails.TaxAmount);

        this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
        let conObj = this.countrycollection.filter(item => item.CountryCode == this.sendMoneyDetail.pickupTypeDetails.countryPreference);

        if (conObj.length > 0) {
            let curobj = conObj[0].Currencies.filter(item => item.CurrencyCode == this.sendMoneyDetail.agentDetails.CurrencyTo);
            if (curobj.length > 0) {
                this.RoundingPlaces = curobj[0].RoundingPlaces;
            }
        }

        this.model.srcAmount = this.currencyPipe.parse(this.paymentDetails.srcAmount.toString());
        this.model.destAmount = this.currencyPipe.parse(this.paymentDetails.destAmount.toString());
        this.model.srcAmount = this.amountFormat.transform(this.model.srcAmount.toString());
        this.model.destAmount = this.amountFormat.transform(this.model.destAmount.toString());
        this.buttonName = this.translate.instant('Summary_btnPay');
        if (PaymentType.PayAtStore === this.sendMoneyDetail.paymentDetails.paymentType) {
            this.buttonName = this.translate.instant('PayAtStore_title');
        }
        this.loadCountryImageFile();
    }

    ngOnInit() {
        this.srcRadio = true;
        this.dstRadio = false;
        this.valueChangeForward(true);
        this.threatMetrixService.Init();
    }

    loadCountryImageFile() {
        this.utilityServ.getCountryImage(this.sendMoneyDetail.agentDetails.CountryFrom).subscribe(
            res => {
                this.srcCountryImage = res;
            },
            error => {
                //console.log(error);
            }
        );
        this.utilityServ.getCountryImage(this.sendMoneyDetail.agentDetails.CountryTo).subscribe(
            res => {
                this.destCountryImage = res;
            },
            error => {
                //console.log(error);
            }
        );
    }

    // supersendClick() {
    //   let self = this;
    //   let modalData: any = {};
    //   this.actionFlag = false;

    //   modalData.srcAmount = this.paymentDetails.srcAmount;
    //   modalData.srcAmountIsDisabled = true;
    //   modalData.page = 'summary';
    //   modalData.LocationId = this.sendMoneyDetail.agentDetails.LocationId;
    //   modalData.CountrySupportedCurrencyCodesTo = this.sendMoneyDetail.agentDetails.CountrySupportedCurrencyCodesTo;
    //   modalData.ProgramId = this.sendMoneyDetail.agentDetails.ProgramId;
    //   modalData.DeliveryMethod = this.sendMoneyDetail.agentDetails.DeliveryMethod;
    //   modalData.CountryCodeTo = this.sendMoneyDetail.agentDetails.CountryTo;
    //   this.modal.overlay.defaultViewContainer = this.vcRef;
    //   return this.modal.open(DashboardSupersendComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
    //     obj.onDestroy.subscribe(data => {
    //       if (modalData.next === 'yes') {
    //         let subProgramDetailData = self.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
    //           self.sendMoneyDetail.sendMoneyProgramDetail = data;
    //           self.sendMoneyDetail.agentDetails.ProgramId = data.ProgramId;
    //           if (subProgramDetailData != undefined) {
    //             subProgramDetailData.unsubscribe();
    //           }
    //         });

    //         self.loadBranchDetail();
    //         self.subscription = self.observable.subscribe(x => {
    //           if (x == true) {
    //             self.errorPopupWithOK(self.translate.instant('AddToCartSuccess_title'), self.translate.instant('ExchangeFeeReviewPopup_desc'));
    //             return false;
    //           } else {
    //             //
    //           }
    //           if (self.subscription != undefined) {
    //             self.subscription.unsubscribe();
    //           }
    //         });
    //       }
    //     });
    //   });
    // }

    loadBranchDetail() {
        //console.log("Es el 1");
        this.sendMoneyDetail.agentDetails.Amount = this.sendMoneyDetail.paymentDetails.srcAmount;
        this.utilityServ.busy = this.sendMoneyService.getBranchDetails(this.sendMoneyDetail.agentDetails).subscribe(
            data => {
                if (data.StatusCode == 10000 && data.Branches != null) {
                    this.isBranchDetailsUpdated = true;
                    if (Number(this.paymentDetails.exchangeRate) != Number(data.Branches[0].RateCustomer) || Number(this.paymentDetails.processingFee) != Number(data.Branches[0].CustomerFee ) || Number(this.paymentDetails.TaxAmount) != Number(data.Branches[0].TaxAmount)) {
                        this.sendMoneyDetail.branchDetails = data.Branches[0];
                        this.sendMoneyDetail.branches = data.Branches;

                        this.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
                        this.paymentDetails.TaxAmount = parseFloat(this.sendMoneyDetail.branchDetails.TaxAmount.toString());
                        this.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
                        this.Rate = Number(this.paymentDetails.exchangeRate);
                        this.Fee = Number(this.paymentDetails.processingFee);
                        this.TaxAmount = this.paymentDetails.TaxAmount;
                        if (this.sendMoneyDetail.branchDetails.MinimumDenomination != null) {
                            this.paymentDetails.minimumDenomination = parseFloat(this.sendMoneyDetail.branchDetails.MinimumDenomination.toString());
                        } else {
                            this.paymentDetails.minimumDenomination = 0;
                        }

                        if (this.sendMoneyDetail.branchDetails.MaximumLocalAmount != null) {
                            this.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.branchDetails.MaximumLocalAmount.toString());
                        } else {
                            this.paymentDetails.maxAllowedLimit = 0;
                        }

                        if (!this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee && this.paymentDetails.maxAllowedLimit > 0) {
                            this.paymentDetails.maxAllowedLimit = this.paymentDetails.maxAllowedLimit - this.Fee;
                        }

                        if (this.paymentDetails.maxAllowedLimit == 0 || this.paymentDetails.maxAllowedLimit > parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)) {
                            this.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit);
                        }

                        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        // return true;
                        //this.valueChangeForward();
                        // if (this.actionFlag) {
                        this.clickStream.next(true);
                        // }
                    } else {
                        // return false;
                        // if (this.actionFlag) {
                        this.clickStream.next(false);
                        // }
                    }
                } else {
                    this.isFormValid = false;
                    const _self = this;
                    let modalData: any = {};
                    modalData.Action = this.translate.instant('Common_lblOk');
                    modalData.Title = this.translate.instant('Common_lblOops').toString();
                    modalData.Message = this.translate.instant('Message_errorMessage').toString();
                    this.modal.overlay.defaultViewContainer = this.vcRef;
                    return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                            //console.log('Observer got a next value: ' + data);
                            if (modalData.next == 'yes') {
                                _self.sendMoneyService.setDeactivateSummaryFlag(true);
                                _self.router.navigate(['/dashboard']);
                            }
                        });
                    });
                }
            },
            error => {
                //console.log('Observer got a next value: ' + error);
            }
        );
    }



    valueChangeForward(isFirstLoad: boolean = false) {

        if (isFirstLoad == true) {

            this.model.srcAmount = this.paymentDetails.srcAmount.toFixed(2);
            this.model.destAmount = this.paymentDetails.destAmount.toFixed(this.RoundingPlaces || 2);

        } else {

            this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));

            this.loadBranchDetail();

            let subscription = this.observable.subscribe(branchInfoChanged => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                if (branchInfoChanged === true) {
                    this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));
                }

                this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                this.isAmountExceed(this.paymentDetails.srcAmount);

            });
        }
    }

    private calculateFromLocalAmount(localAmount: number) {

        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0 && localAmount > maxAllowedLimit) {
            localAmount = maxAllowedLimit;
        }

        this.calculateFromTransferAmount(localAmount * this.Rate);

    }

    timeout: any = null;

    public onKeySearch(event: any) {

        let _localAmtChanged = this.LocalAmountChanged()
        let _transferAmtChanged = this.TransferAmountChanged()

        if (_localAmtChanged || _transferAmtChanged) {

            clearTimeout(this.timeout);

            this.srcRadio = _localAmtChanged;
            this.dstRadio = _transferAmtChanged;

            var $this = this;

            $this.timeout = setTimeout(function () {

                if ((_localAmtChanged && !$this.model.srcAmount || isNaN($this.model.srcAmount)) || (_transferAmtChanged && !$this.model.destAmount || isNaN($this.model.destAmount))) {
                    $this.model.srcAmount = '0.00';
                    $this.model.destAmount = '0.00';
                    $this.paymentDetails.srcAmount = 0.00;
                    $this.paymentDetails.destAmount = 0.00;
                    $this.paymentDetails.totalAmount = 0.00;
                } else {

                    $this.TriggerAmountChanged();

                }

            }, 2000);
        }
    }

    private TriggerAmountChanged() {

        if (this.srcRadio === true) {
            this.valueChangeForward();
        }

        if (this.dstRadio === true) {
            this.valueChangeBackward();
        }
    }

    private LocalAmountChanged() {
        return this.AmountChanged(this.model.srcAmount, this.paymentDetails.srcAmount, 2);
    }

    private TransferAmountChanged() {
        return this.AmountChanged(this.model.destAmount, this.paymentDetails.destAmount, this.RoundingPlaces || 2);
    }

    private AmountChanged(_newAmount: any, _oldAmount: any, precision: number) {

        let _newAmountNumber: any = Number(_newAmount);
        let _oldAmountNumber: any = Number(_oldAmount);

        if (!isNaN(_newAmountNumber)) {
          _newAmountNumber = _newAmountNumber.toFixed(precision);
        }

        if (!isNaN(_oldAmountNumber)) {
          _oldAmountNumber = _oldAmountNumber.toFixed(precision);
        }

        if (isNaN(_newAmountNumber) && isNaN(_oldAmountNumber)) {
            return _newAmount !== _oldAmount;
        } else {
            return _newAmountNumber !== _oldAmountNumber;
        }
    }

    valueChangeBackward() {

        this.calculateFromTransferAmount(Number(this.model.destAmount || 0));

        this.loadBranchDetail();

        let subscription = this.observable.subscribe(branchInfoChanged => {

            if (subscription != undefined) {
                subscription.unsubscribe();
            }

            if (branchInfoChanged === true) {
                this.calculateFromTransferAmount(Number(this.model.destAmount || 0));
            }

            this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
            this.isAmountExceed(this.paymentDetails.srcAmount);

        });
    }

    private calculateFromTransferAmount(transferAmount: number) {

        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0) {
            transferAmount = (transferAmount / this.Rate) <= maxAllowedLimit ? transferAmount : maxAllowedLimit * this.Rate;
        }

        let minimumDenomination = this.paymentDetails.minimumDenomination;

        if (minimumDenomination > 0) {

            let ceilTransferAmount = Math.ceil(transferAmount / minimumDenomination) * minimumDenomination;
            let floorTransferAmount = Math.floor(transferAmount / minimumDenomination) * minimumDenomination;

            if (maxAllowedLimit > 0) {
                transferAmount = (ceilTransferAmount / this.Rate) <= maxAllowedLimit ? ceilTransferAmount : floorTransferAmount;
            } else {
                transferAmount = ceilTransferAmount;
            }
        }

        let localAmount = transferAmount / this.Rate;

        this.model.srcAmount = localAmount.toFixed(2);
        this.model.destAmount = transferAmount.toFixed(this.RoundingPlaces || 2);

        this.paymentDetails.srcAmount = localAmount;
        this.paymentDetails.destAmount = Number(transferAmount.toFixed(this.RoundingPlaces || 2));
        this.paymentDetails.totalAmount = Number(localAmount.toFixed(2)) + Number(this.Fee) + Number(this.TaxAmount);
        this.sendMoneyDetail.paymentDetails = this.paymentDetails;

    }

    isAmountExceed(amount: number) {
        let flag = true;
        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;
        // amount = amount + this.Fee;
        if (maxAllowedLimit == 0) {
            flag = false;
        } else {
            flag = amount > maxAllowedLimit ? true : false;
        }
        if (flag) {
            let modalData: any = {};
            modalData.Title = this.translate.instant('Common_lblInfo').toString();
            modalData.Message =
                this.translate.instant('InputAmount_amountExceedPre') +
                ' ' +
                this.paymentDetails.srcCurrCode +
                ' ' +
                parseFloat(this.paymentDetails.maxAllowedLimit.toString()) +
                ' ' +
                this.translate.instant('InputAmount_amountExceedPost');
            modalData.Action = this.translate.instant('Common_lblOk').toString();
            if (this.isModalOpen == false) {
                this.isModalOpen = true;
                const _self = this;
                this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        //console.log('Observer got a next value: ' + data);
                        _self.isModalOpen = false;
                    });
                });
            }
            return true;
        } else {
            return false;
        }
    }

    isValidDenomination(amount: number) {
        let denomination = this.paymentDetails.minimumDenomination;
        denomination = denomination != null && denomination !== undefined && !isNaN(denomination) ? denomination : 0;
        if (denomination == 0) {
            return true;
        }
        if (amount % denomination == 0) {
            return true;
        } else {
            this.errorPopup(this.translate.instant('Common_lblInfo'), this.translate.instant('InputAmount_errorDenominationDesc') + denomination);
            return false;
        }
    }

    cancel() {
        let modalData: any = {};
        const _self = this;
        modalData.Title = this.translate.instant('Common_lblConfirm').toString();
        modalData.Message = this.translate.instant('SendMoneyCancelPopup_desc').toString();
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                //console.log('Observer got a next value: ' + data);
                if (modalData.next == 'yes') {
                    _self.sendMoneyService.setDeactivateSummaryFlag(true);
                    _self.router.navigate(['/dashboard']);
                }
            });
        });
    }

    supersendLoad() {

        let self = this;
        let modalData: any = {};
        this.actionFlag = false;
        // Bharat modalData.destAmount = this.paymentDetails.destAmount;
        modalData.srcAmount = this.paymentDetails.srcAmount;
        modalData.srcAmountIsDisabled = true;
        modalData.page = 'summary';
        modalData.LocationId = this.sendMoneyDetail.agentDetails.LocationId;
        modalData.CountrySupportedCurrencyCodesTo = this.sendMoneyDetail.agentDetails.CountrySupportedCurrencyCodesTo;
        modalData.ProgramId = this.sendMoneyDetail.agentDetails.ProgramId;
        modalData.DeliveryMethod = this.sendMoneyDetail.agentDetails.DeliveryMethod;
        modalData.CountryCodeTo = this.sendMoneyDetail.agentDetails.CountryTo;
        modalData.beneficiary = this.sendMoneyDetail.beneficiaryDetails;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let reqObj: any = {};
        reqObj.CurrencyCodeTo = this.sendMoneyDetail.agentDetails.CurrencyTo;

        this.utilityServ.busy = this.dbService.getProgramDetails(reqObj).subscribe(
            data => {
                if (data.StatusCode == 20001) {
                    return false;
                }
                if (data.StatusCode == 10000) {
                    if (data.Programs != '' && data.Programs != 0) {
                        modalData.arrPrograms = data.Programs.split(',');
                        modalData.max = modalData.arrPrograms.length - 1;
                        // this.getSuperSendDetails();
                        return this.modal.open(DashboardSupersendComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                if (modalData.next === 'yes') {
                                    const subProgramDetailData = self.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
                                        self.sendMoneyDetail.sendMoneyProgramDetail = data;
                                        self.sendMoneyDetail.agentDetails.ProgramId = data.ProgramId;
                                        if (subProgramDetailData != undefined) {
                                            subProgramDetailData.unsubscribe();
                                        }
                                    });

                                    self.subSupersendCall.next(true);
                                } else {
                                    self.subSupersendCall.next(false);
                                }
                            });
                        });
                    } else {
                        self.subSupersendCall.next(false);
                    }
                } else {
                    self.subSupersendCall.next(false);
                }
            },
            error => { }
        );
    }

    AddToCartOnClick(type: string) {

        if (this.LocalAmountChanged() || this.TransferAmountChanged()) {

            clearTimeout(this.timeout);

            this.srcRadio = this.LocalAmountChanged();
            this.dstRadio = this.TransferAmountChanged();

            this.TriggerAmountChanged();

            let subscription = this.observable.subscribe(() => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                this.addToCart(type);

            });
        } else {
            this.addToCart(type);
        }
    }

    addToCart(type: string) {

        this.actionFlag = true;
        if (this.paymentDetails.srcAmount <= 0) {
            this.errorPopup(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('Common_lblAmountZero'));
            return false;
        }
        if (this.paymentDetails.destAmount <= 0) {
            this.errorPopup(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('Common_lblDestinationAmountZero'));
            return false;
        }
        if (this.isAmountExceed(this.paymentDetails.srcAmount) && this.isValidDenomination(this.paymentDetails.destAmount)) {
            return false;
        }
        // check location is permissionable
        // this.geoGraphicalCheck();

        this.utilityServ.busy = this.geoloc.islocPermissionable().subscribe(data => {
            //console.log("Data", data)
            if (data == undefined) {
                return;
            }
            if (data == true) { 
                // suprsend logic will go here
                this.sendMoneyDetail.paymentDetails = this.paymentDetails;
                this.supersendLoad();
                const unsubsubSupersendCall = this.subSupersendCall.subscribe(useSuperSend => {

                    if (useSuperSend == true) {

                        this.loadBranchDetail();

                        this.subscription = this.observable.subscribe(branchInfoChanged => {

                            if (this.subscription != undefined) {
                                this.subscription.unsubscribe();
                            }

                            if (branchInfoChanged == true) {

                                this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));

                                this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                                this.isAmountExceed(this.paymentDetails.srcAmount);

                                if (this.sendMoneyDetail.agentDetails.ProgramId == 0) {
                                    this.errorPopupWithOK(this.translate.instant('AddToCartSuccess_title'), this.translate.instant('ExchangeFeeReviewPopup_desc'));
                                    return false;
                                }
                            }

                            this.addtoCartProcess(type);

                        });
                    } else {
                        this.addtoCartProcess(type);
                    }

                    if (unsubsubSupersendCall != undefined) {
                        unsubsubSupersendCall.unsubscribe();
                    }

                });
            } else {
                this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_areaPermissibleError'));
                return false;
            }
        },
            error => { }
        );
    }

    addtoCartProcess(type) {

        if (type == 'pay') {
            if (!this.isDocUploaded) {
                this.isdocumentRequiredCheck();
                this.unsubDocReq = this.observableDocReq.subscribe(x => {
                    if (x == false) {
                        this.addingtocart(type);
                    } else if (x == true) {
                        this.uploadDocument(type);
                    } else {
                        this.errorPopupWithOK(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                    }
                    if (this.unsubDocReq != undefined) {
                        this.unsubDocReq.unsubscribe();
                    }
                });
            } else {
                this.addingtocart(type);
            }
        } else {
            this.addingtocart(type);
        }
    }
    uploadDocument(type) {

        const _self = this;
        let modalData: any = {};
        modalData.DocumentRequired = this.DocumentRequired;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(uploaddocumtuserprofilestep1, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
                if (modalData.Status == false) {
                    return;
                }
                if (modalData.Status == true) {
                    modalData.Status = false;

                    return _self.modal.open(uploaddocumtuserprofilestep2, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                            if (modalData.Status == false) {
                                return;
                            }
                            if (modalData.Status == true) {
                                _self.addingtocart(type);
                                _self.isDocUploaded = true;
                            } else {
                                _self.errorPopupWithOK(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
                            }
                        });
                    });
                } else {
                    _self.errorPopupWithOK(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
                }
            });
        });
    }

    addingtocart(type: string) {

        this.addCartItem(type);
    }

    getErrorList(data: any): any[] {
    // Verifica si CoreError, Errors y ErrorList existen
    const coreError = data.Envelope.Body.AddToCartResponse.CoreError;
    if (!coreError) return [];
    
    const errors = coreError.Errors;
    if (!errors) return [];
    
    const errorList = errors.ErrorList;
    if (!errorList) return [];
    
    // Convierte a array si es un objeto único
    return Array.isArray(errorList) ? errorList : [errorList];
}

    addCartItem(type: string) {
        // //console.log(
        //     this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail)
        // );
        let self = this;
        let userGioLocation = new UserGioLocation();
        this.geoloc.getGioLocation().subscribe(data => {
            userGioLocation = data;
            this.geoloc.setserGioLocation(data);
            this.sendMoneyDetail.roundingPlaces = this.RoundingPlaces;
            this.utilityServ.busy = this.cartservice.addCartItem(this.sendMoneyDetail, userGioLocation).subscribe(
                data => {

                    let errorList = [];
                    if (data.Envelope.Body.AddToCartResponse.StatusCode != enumStatusCodeList.SUCCESS) {
                         //console.log("status code order", data.Envelope.Body.AddToCartResponse.StatusCode)
                        //console.log("status code", data.Envelope.Body.AddToCartResponse.CoreError.Errors.ErrorList)
                        //console.log("status code lenght", data.Envelope.Body.AddToCartResponse.CoreError.Errors.ErrorList.length)

                        errorList = this.getErrorList(data); // Si no hay errores, array vacío

                        if (errorList.length > 0) {
                            // Extrae el código del primer error (8001 en tu ejemplo)
                            let firstErrorCode = errorList[0].Code.__text;
                            
                            // Modifica el StatusCode con el valor del primer error
                            data.Envelope.Body.AddToCartResponse.StatusCode = firstErrorCode;
                            
                            //console.log("Nuevo StatusCode:", data.Envelope.Body.AddToCartResponse.StatusCode); // Debería mostrar 8001
                        }
                    }
                   

                    if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                        this.shopingCart = new ShopingCart();
                        this.sendMoneyDetail.shopingCartList = new Array<ShopingCart>(); //new ShopingCartList();
                        this.shopingCart.itemId = data.Envelope.Body.AddToCartResponse.ItemId;
                        this.sendMoneyDetail.shopingCartList.push(this.shopingCart);
                        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('AddToCartSuccess_title').toString();
                        modalData.Action = this.translate.instant('Common_lblContinue');
                        //const RateExpiresOn = moment(data.Envelope.Body.AddToCartResponse.RateExpiresOn).format('dd-MM-yyyy ');
                        //const RateExpiresOn = written(this.sendMoneyDetail.currentCartDetail.CartExpiry, { lang: sessionStorage.langCode }); //data.Envelope.Body.AddToCartResponse.RateExpiresOn;
                        const RateExpiresOn = this.sendMoneyDetail.currentCartDetail.CartExpiry;
                        const ItemCount = data.Envelope.Body.AddToCartResponse.ItemCount;
                        let Message1 =
                            this.translate.instant('Common_lblExchangeRateDesc').toString() + ' <strong class="redColor">' + RateExpiresOn + ' ' + this.translate.instant('AddToCartSuccess_hourDesc') + '</strong>';
                        // Message1 = Message1.replace("ONE HOUR", RateExpiresOn);

                        let itemText = ItemCount > 1 ? this.translate.instant('AddToCartSuccess_itemsDesc') : this.translate.instant('AddToCartSuccess_itemDesc');
                        modalData.Message = Message1;

                        let Message2 = this.translate.instant('AddToCartSuccess_transPre').toString();
                        // Message2 += ' <strong class="redColor">' + written(ItemCount, { lang: sessionStorage.langCode });
                        Message2 += ' <strong class="redColor">' + ItemCount;
                        Message2 += ' ' + itemText + '</strong>';
                        Message2 += ' ' + this.translate.instant('AddToCartSuccess_transPost');

                        if (type == 'add') {

                            return self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                                obj.onDestroy.subscribe(data => {
                                    if (modalData.next == 'yes') {
                                        modalData.Message = Message2;
                                        return self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                                            obj.onDestroy.subscribe(data => {
                                                if (modalData.next == 'yes') {
                                                    self.sendMoneyService.setDeactivateSummaryFlag(true);
                                                    self.router.navigate(['/shoppingcart']);
                                                }
                                            });
                                        });
                                    }
                                });
                            });
                        } else {
                            let transactionId = this.utilityServ.getObjectText(data.Envelope.Body.AddToCartResponse.ItemId);
                            this.payClick(transactionId);
                            // this.utilityServ.busy = this.cartservice.getcartlistservice().subscribe(data => {
                            //   if (data.Envelope.Body.GetCartItemResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                            //     let transactionId = this.utilityServ.getObjectText(data.Envelope.Body.GetCartItemResponse.CartCode);
                            //     this.payClick(transactionId);
                            //   } else {
                            //     this.errorPopup(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_lblPaymentFailed'));
                            //   }
                            // });
                        }
                    } else if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.fieldsRequiredInOrder) {
                        //console.log("entra a campos requeridos", data.Envelope.Body)
                        if (
                                errorList.length > 0
                            ) {
                                // Recorre el arreglo y extrae los valores de `Field.__text`
                                const fieldsText = errorList
                                    .map(error => error.Field.__text)
                                    .filter(Boolean)
                                    .join(', ');

                                //console.log("Campos con errores:", fieldsText);
                                this.openMissingInfo(fieldsText, type);
                            } else {
                            //console.log("No hay campos con errores.");
                        }
                        
                    } else if (data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.ComplianceError) {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = data.Envelope.Body.AddToCartResponse.StatusMessage;
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => { });
                        });
                    } else if (
                        data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.Invalid_bank_account1 ||
                        data.Envelope.Body.AddToCartResponse.StatusCode == enumStatusCodeList.Invalid_bank_account2
                    ) {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = this.translate.instant('AddToCartFailure_Code_9071_9072');
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => { });
                        });
                    } else {
                        let modalData: any = {};
                        modalData.Title = this.translate.instant('Common_lblOops').toString();
                        modalData.Action = this.translate.instant('Common_lblOk');
                        modalData.Message = type == 'pay' ? this.translate.instant('AddToCartFailure_paymentFailDesc') : this.translate.instant('AddToCartFailure_cartFailDesc');
                        // data.Envelope.Body.AddToCartResponse.StatusMessage;
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                // if (modalData.next == 'yes') {
                                //   self.router.navigate(['/dashboard']);
                                // }
                            });
                        });
                    }
                },
                error => { }
            );
        });
    }
    // this method will Pay the cart amount
    payClick(transactionId: number) {
        let reqObject: any;
        const _self = this;
        this.userProfileTMNIovation = new UserProfileTMNIovation();
        this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
        this.userProfileTMNIovation.eventType = enumEventype[enumEventype.Payment];
        this.userProfileTMNIovation.transactionAmount = this.sendMoneyDetail.paymentDetails.totalAmount;
        this.userProfileTMNIovation.transactionCurrency = this.sendMoneyDetail.paymentDetails.srcCurrCode;
        this.userProfileTMNIovation.transactionId = transactionId;
        this.userProfileTMNIovation.userProfile = this.sendMoneyDetail.userDetails;

        this.sendMoneyDetail.transactionId = transactionId;
        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);

        if (!_self.fraudDetectionPromise) {

            _self.fraudDetectionPromise = new Promise((resolve, reject) => {

                _self.threatMetrixService.Profile().then(sessionId => {
                    _self.userProfileTMNIovation.deviceProfile.SessionID = sessionId;
                    _self.utilityServ.busy = _self.auth.profileTMnIovation(_self.userProfileTMNIovation).subscribe(data => {

                        if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
                            resolve(data);
                        } else {
                            reject(data);
                        }
                    });
                });
            });
        }

        this.fraudDetectionPromise.then(data => {

            _self.utilityServ.busy = _self.sendMoneyService.pay(_self.sendMoneyDetail).subscribe(
                data => {
                    if (data.Envelope.Body.PaymentResponse.StatusCode == -10000) {
                        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                    } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
                        return false;
                    } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                        _self.sendMoneyService.setDeactivateSummaryFlag(true);
                        _self.router.navigate(['/PaymentReceipt']);
                    } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.Transactioninprocess || data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.Transactionnotfound) {
                        this.errorPopup(this.translate.instant('Common_lblOops'), data.Envelope.Body.PaymentResponse.StatusMessage);
                    } else {
                        let modalData: any = {};
                        modalData.Title = _self.translate.instant('Common_lblOops').toString();
                        modalData.Message = _self.translate.instant('Message_lblPaymentFailed').toString();
                        modalData.Action = _self.translate.instant('Common_lblOk').toString();
                        _self.modal.overlay.defaultViewContainer = _self.vcRef;
                        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                if (modalData.next == 'yes') {
                                    _self.sendMoneyService.setDeactivateSummaryFlag(true);
                                    _self.router.navigate(['/shoppingcart']);
                                }
                            });
                        });
                    }
                },
                error => { }
            );
        }, errorData => {
            this.errorPopup(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_lblPaymentFailed'));
        });
    }

    isdocumentRequiredCheck() {
        let reqObj: any;
        this.utilityServ.busy = this.sendMoneyService.documentRequiredCheck().subscribe(
            data => {
                if (data.Envelope.Body.DocumentRequiredResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    if (
                        data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxID == 'true' ||
                        data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxIdForUSID == 'true' ||
                        data.Envelope.Body.DocumentRequiredResponse.RequireCustomerID == 'true'
                    ) {
                        this.DocumentRequired = data.Envelope.Body.DocumentRequiredResponse;
                        this.subDocReq.next(true);
                    } else {
                        this.subDocReq.next(false);
                    }
                } else {
                    this.errorPopupWithOK(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
                }
            },
            error => { }
        );
    }

    fraudDetectionCheck() {
        // some code here
    }

    // open modal to fill required additional information
    openMissingInfo(data: string, type: string) {
        let additionalRequiredFields: AdditionalRequired = new AdditionalRequired();
        let paramsRequired: any = data.split(',').map(item => item.trim()); 

        let flag: boolean = false;
        paramsRequired.forEach(element => {
            switch (element) {
                case 'CustomerOccupation':
                    additionalRequiredFields.IsCustomerOccupationRequired = true;
                    flag = true;
                    break;
                case 'CustomerEmployer':
                    additionalRequiredFields.IsCustomerEmployerRequired = true;
                    flag = true;
                    break;
                case 'FundSource':
                    additionalRequiredFields.IsFundSourceRequired = true;
                    flag = true;
                    break;
                case 'TransferReason':
                    additionalRequiredFields.IsTransferReasonRequired = true;
                    flag = true;
                    break;
                case 'BeneficiaryRelation':
                    additionalRequiredFields.IsBeneficiaryRelationRequired = true;
                    flag = true;
                    break;
                case 'Beneficiary_Address':
                    additionalRequiredFields.IsBeneficiaryAddressRequired = true;
                    flag = true;
                    break;
                default:
                    break;
            }
        });

        if (flag) {
            const modalData: any = {};
            modalData.page = 'summary';
            const _self = this;
            this.sendMoneyDetail.branchDetails.SummaryValidation = additionalRequiredFields;
            this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
            this.modal.overlay.defaultViewContainer = this.vcRef;
            return this.modal.open(AdditionalInfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.onNext == 'yes') {
                        //_self.addToCart(type);
                        _self.addtoCartProcess(type);
                    }
                });
            });
        }
    }

    errorPopup(title, message) {
        let modalData: any = {};
        modalData.Title = title;
        modalData.Message = message;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }
    errorPopupWithOK(title, message) {
        let modalData: any = {};
        modalData.Title = title;
        modalData.Message = message;
        modalData.Action = this.translate.instant('Common_lblOk');
        this.modal.overlay.defaultViewContainer = this.vcRef;
        this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }
    ngOnDestroy() {
        // this.sendMoneyService.resetAllData();
    }
    // formatAmount(event) {
    //   event.currentTarget.value = this.currencyPipe.parse(event.currentTarget.value); // event.currentTarget.value.replace('$', '');
    // }

    formatAmount(event) {
        event.currentTarget.value = this.amountFormat.transform(event.currentTarget.value); //this.amountFormat.transform(event.currentTarget.value); // event.currentTarget.value.replace('$', '');
    }

    revformatAmount(event) {
        event.currentTarget.value = event.currentTarget.value.replace(/[^0-9-.]/g, '');
        event.currentTarget.value = Number(event.currentTarget.value) == 0 ? '' : event.currentTarget.value;
    }

    retAmount(amount) {
        let val = amount.replace(/[^0-9-.]/g, '');
        return parseFloat(Number(val).toFixed(AppSettings.fractionDigit));
    }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/summary/summary.component.ts